module.exports = __webpack_public_path__ + "static/media/avatar.1966ef9e.svg";